/**
 * Utility to lazy load the WayForPay widget script
 */
export const loadWayForPayWidget = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    // Check if already loaded
    if ((window as any).Wayforpay) {
      resolve((window as any).Wayforpay);
      return;
    }

    // Check if script tag already exists
    const existingScript = document.getElementById('widget-wfp-script');
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        if ((window as any).Wayforpay) {
          resolve((window as any).Wayforpay);
        } else {
          reject(new Error('WayForPay script loaded but object not found'));
        }
      });
      return;
    }

    // Create and append script
    const script = document.createElement('script');
    script.id = 'widget-wfp-script';
    script.src = 'https://secure.wayforpay.com/server/pay-widget.js';
    script.async = true;
    script.onload = () => {
      if ((window as any).Wayforpay) {
        resolve((window as any).Wayforpay);
      } else {
        reject(new Error('WayForPay script loaded but object not found'));
      }
    };
    script.onerror = () => reject(new Error('Failed to load WayForPay widget script'));
    document.body.appendChild(script);
  });
};
